import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BAinMarketingManagement = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160px',marginLeft: '70px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 Bachelor of Arts in Marketing Management</h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BA in Marketing Management program at Admas University is designed to develop creative, analytical, and strategic marketing professionals. Students will gain in-depth knowledge of consumer behavior, digital marketing, branding, sales, and market research to meet the demands of modern businesses.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To equip students with modern marketing tools and strategies.</li>
          <li>To develop skills in branding, sales, advertising, and digital marketing.</li>
          <li>To prepare students for leadership roles in marketing and sales departments.</li>
          <li>To foster innovation and creativity in solving market challenges.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Core Courses</h2>
        <ul>
          <li>Principles of Marketing</li>
          <li>Consumer Behavior</li>
          <li>Digital Marketing Strategies</li>
          <li>Sales and Promotion Management</li>
          <li>Marketing Research</li>
          <li>Brand Management</li>
          <li>International Marketing</li>
          <li>Strategic Marketing Planning</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Completion of the Ethiopian Higher Education Entrance Certificate (Grade 12 national exam).</li>
          <li>TVET Level IV graduates with COC certificate may enter via bridging program.</li>
          <li>Transfer from other accredited institutions is allowed under university policy.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates can work as marketing managers, sales executives, brand consultants, market analysts, digital marketing specialists, and customer relationship managers across diverse industries.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University?</h2>
        <ul>
          <li>Nationally accredited curriculum aligned with market needs.</li>
          <li>Highly qualified instructors with real-world experience.</li>
          <li>Hands-on marketing projects and internship programs.</li>
          <li>Accessible learning through campuses across Ethiopia.</li>
          <li>Flexible learning options including regular, evening, and weekend programs.</li>
        </ul>
      </section>
    </div>
  );
};

export default BAinMarketingManagement;